<template>
    <div v-if="mode == 'details'">
        <div class="d-flex mb-3">
            <button type="button" class="btn btn-info btn-sm mr-2" @click="changeMode('modification')">
                <i class="fas fa-edit"></i> Modifier
            </button>

        </div>
        <TabView>
            <TabPanel header="General">
                <FormCaisse :line="datas" :readOnly="true" />
            </TabPanel>

        </TabView>
    </div>
    <div v-else-if="mode == 'modification'">
        <!-- Correction de la syntaxe - il manquait un espace entre le composant et l'attribut -->
        <FormCaisse :line="datas" :readOnly="false" @reset_mode="changeMode" />
    </div>
</template>

<script>
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
const FormCaisse = defineAsyncComponent(() => import('@/views/comptabilite/pieces-de-caisse/FormPieceDeCaisse.vue'));
const ChangeUserState = defineAsyncComponent(() => import('@/components/ChangeUserState.vue'));
const UserAccountActivity = defineAsyncComponent(() => import('@/components/UserAccountActivity.vue'));

export default defineComponent({
    inject: ['dialogRef'],
    components: { FormCaisse, ChangeUserState, UserAccountActivity },
    data() {
        return {
            mode: 'details',
            isLoading: true,
            table: 'piece_de_caisses',
            datas: this.dialogRef.data
        }
    },
    methods: {
        changeMode(mode) {
            if (mode) { this.mode = mode }
            else this.mode = 'details'
        },
        disableLine() {
            if (!window.confirm("Etes-vous sur de vouloir bloquer  ?")) {
                return
            }
            this.isLoading = true
            this.axios.post('/api/caisses/' + this.datas.id + '/disable').then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 20000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        activateLine() {
            if (!window.confirm("Etes-vous sur de vouloir activer cet utilisateur ?")) {
                return
            }
            this.isLoading = true
            this.axios.post('/api/caisses/' + this.datas.id + '/activate').then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 20000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        }
    }
})
</script>